import { IMlAccordionBlockCSProps } from '@/lib/contentstack-sdk/types/component';
import { ReactNode } from 'react';

export type TMlAccordionCS = {
  block: IMlAccordionBlockCSProps;
};

export interface IMlAccordionProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
}

export interface IMlAccordionItemProps {
  index: number;
  title: string;
  children: ReactNode;
  intent?: EAccordionItemIntents;
}

export enum EAccordionItemIntents {
  DEFAULT = 'default',
  NAV = 'nav',
}
